import { html, View } from 'rune-ts';
import { FundingListResponse } from '@services/MarppleShop/features/Funding';
import { pipe, map, toArray } from '@fxts/core';
import { FundingCard } from '@services/MarppleShop/renderApp/components/cells/FundingCard/FundingCard.ts';
import klass from './CreatorShopFundings.module.scss';

export interface FundingCardListProps {
  fundings: FundingListResponse['data'];
  server_timestamp: number;
  is_mobile: boolean;
}

export class FundingCardList extends View<FundingCardListProps> {
  protected override template() {
    return html`
      <div class="${klass.fundings}">
        ${pipe(
          this.data.fundings,
          map(
            (funding) =>
              new FundingCard({
                product_id: funding.productId,
                name: funding.name,
                domain_name: funding.domainName,
                description: funding.description,
                sell_start_at: funding.sellStartAt,
                sell_end_at: funding.sellEndAt,
                goal_amount: funding.goalAmount,
                total_amount: funding.totalAmount,
                thumbnail_info: funding.thumbnailInfo,
                is_quantity_public: funding.isQuantityPublic,
                is_public: funding.isPublic,
                order_count: funding.orderCount,
                quantity: funding.quantity,
                out_of_stock: funding.outOfStock,
                server_timestamp: this.data.server_timestamp,
                is_mobile: this.data.is_mobile,
              }),
          ),
          toArray,
        )}
      </div>
    `;
  }

  public update(data: FundingCardListProps['fundings']) {
    this.data.fundings = data;
    this.redraw();
  }
}
